import { CallState } from "@b2bportal/core-types";
import { AvailabilitySort } from "@b2bportal/rbc-activities-api";
import { ActivityRatingValueEnum } from "../components/FilterRating/FilterRating";
import type {
  ActivityFilterState,
  ActivitiesAvailabilitySearchState,
  ActivitiesAvailabilityState,
} from "./types";

export const initialFiltersState: ActivityFilterState = {
  maxPrice: Number.MAX_SAFE_INTEGER,
  freeCancellation: false,
  categories: [],
  rating: ActivityRatingValueEnum.FourPointFive, // default to 4.5 stars
  duration: [],
  startTime: [],
  popularFeatureTags: [],
};

export const initialActivitiesAvailabilitySearchState: ActivitiesAvailabilitySearchState =
  {
    searchFormValues: {
      dateRange: {
        until: undefined,
        from: undefined,
      },
      place: undefined,
      travelers: 2, // Default to 2 travelers
    },
    sort: AvailabilitySort.Recommended,
    filters: initialFiltersState,
  };

export const initialActivitiesAvailabilityState: ActivitiesAvailabilityState = {
  ...initialActivitiesAvailabilitySearchState,
  activities: {
    state: CallState.NotCalled,
  },
  initialized: false,
};
